var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: "form-pdf-embed" + (_vm.interactive ? "" : " links-disabled") },
    [
      _c("div", {
        ref: "pages",
        staticClass: "form-pdf-pages",
        attrs: { role: "document", "aria-label": _vm.documentLabel }
      }),
      _vm.state === "loading"
        ? _c(
            "div",
            { staticClass: "form-pdf-loading" },
            [
              _c("v-progress-circular", {
                attrs: { indeterminate: "", size: "24", width: "2" }
              })
            ],
            1
          )
        : _vm.state === "error"
        ? _c("p", { staticClass: "form-pdf-error" }, [
            _vm._v(" This PDF couldn't be displayed. "),
            _c(
              "a",
              {
                attrs: {
                  href: _vm.url,
                  target: "_blank",
                  rel: "noopener noreferrer"
                }
              },
              [_vm._v("Open PDF")]
            )
          ])
        : _vm._e(),
      _vm.state !== "error"
        ? _c(
            "a",
            {
              staticClass: "form-pdf-sr-only",
              attrs: {
                href: _vm.url,
                target: "_blank",
                rel: "noopener noreferrer"
              }
            },
            [_vm._v("Open " + _vm._s(_vm.documentLabel))]
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }